import { clsx } from 'clsx';
import { ComponentProps, forwardRef } from 'react';

type PrimitiveTextareaProps = {
  error?: string;
} & ComponentProps<'textarea'>;

const PrimitiveTextarea = forwardRef<
  HTMLTextAreaElement,
  PrimitiveTextareaProps
>(({ error, className, disabled, ...props }, ref) => {
  return (
    <textarea
      ref={ref}
      className={clsx(
        'w-full rounded-md border px-3 py-1.5 text-sm text-base-text',
        {
          'placeholder-neutral-300': !disabled,
          'bg-basic-disabled-bg text-basic-disabled-main placeholder-basic-disabled-main':
            disabled,
          'border-neutral-200': !error,
          'border-error-100': error,
        },
        className,
      )}
      disabled={disabled}
      {...props}
    />
  );
});

PrimitiveTextarea.displayName = 'PrimitiveTextarea';

export default PrimitiveTextarea;
